import { useEffect, useRef, useState } from "react";
import ScrollFeedback from "./ScrollFeedback";
import "./DebordZine.css";

const conveyorWords = ["WANDER", "TALK", "PLAY", "CREATE", "LOVE"];
const identityVerbs = ["wear", "buy", "listen to", "read", "watch", "buy"];
const identityBrands = ["Nike", "Chanel", "The Cure", "Niethzsche", "A24", "organic"];
const identityLabels = ["an athlete", "luxorius", "goth", "an intellectual", "a cinephile", "saving the planet"];
const representationWords = [
  "Concerts",
  "Travel",
  "Vacation",
  "Food",
  "Relationships",
  "Friends",
  "Birthdays",
  "Weddings",
  "Proposals",
  "Parenthood",
  "Fitness",
  "Reading",
  "Music",
  "Movies",
  "Fashion",
  "Hobbies",
  "Art",
  "Nature",
  "Nightlife",
  "Festivals",
  "Activism",
  "Charity",
  "Education",
  "Work",
  "Self-care",
  "Religion",
  "Cooking",
];
const conveyorSegments = [];
let phrasesSinceConveyorWord = 0;
let nextConveyorWordAfter = 1 + Math.floor(Math.random() * 2);

for (let index = 0; index < 10; index += 1) {
  conveyorSegments.push({ type: "phrase", id: `phrase-${index}` });
  phrasesSinceConveyorWord += 1;

  if (phrasesSinceConveyorWord === nextConveyorWordAfter && index < 9) {
    const word = conveyorWords[Math.floor(Math.random() * conveyorWords.length)];
    conveyorSegments.push({ type: "word", id: `word-${index}`, text: word });
    phrasesSinceConveyorWord = 0;
    nextConveyorWordAfter = 1 + Math.floor(Math.random() * 2);
  }
}

const DebordZine = () => {
  const conveyorRef = useRef(null);
  const noticeRef = useRef(null);
  const [representationWordIndex, setRepresentationWordIndex] = useState(0);
  const [identityCycleIndex, setIdentityCycleIndex] = useState(0);
  const [dismissedStickerNumbers, setDismissedStickerNumbers] = useState(() => new Set());
  const identityCycleLength = Math.max(
    identityVerbs.length,
    identityBrands.length,
    identityLabels.length
  );
  const getIdentityCycleItem = (items) =>
    items.length ? items[identityCycleIndex % items.length] : "";
  const identityVerb = getIdentityCycleItem(identityVerbs);
  const identityBrand = getIdentityCycleItem(identityBrands);
  const identityLabel = getIdentityCycleItem(identityLabels);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return undefined;
    }

    const wordTimer = window.setInterval(() => {
      setRepresentationWordIndex((index) => (index + 1) % representationWords.length);
    }, 200);

    return () => window.clearInterval(wordTimer);
  }, []);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return undefined;
    }

    const identityTimer = window.setInterval(() => {
      setIdentityCycleIndex((index) => (index + 1) % identityCycleLength);
    }, 2600);

    return () => window.clearInterval(identityTimer);
  }, [identityCycleLength]);

  useEffect(() => {
    const conveyor = conveyorRef.current;
    if (
      !conveyor ||
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      return undefined;
    }
    const randomWords = conveyor.querySelectorAll(".zine-conveyor-insert");
    const previousPositions = new Map();
    const armedWords = new Set();
    let animationFrame;

    const checkWordPositions = () => {
      const centerX =
        conveyor.getBoundingClientRect().left + conveyor.clientWidth / 2;

      randomWords.forEach((word) => {
        const bounds = word.getBoundingClientRect();
        const wordCenter = bounds.left + bounds.width / 2;
        const previousCenter = previousPositions.get(word);

        if (previousCenter === undefined) {
          if (wordCenter > centerX) armedWords.add(word);
        } else if (previousCenter <= centerX && wordCenter > centerX) {
          word.classList.remove("is-launched");
          armedWords.add(word);
        } else if (
          armedWords.has(word) &&
          previousCenter > centerX &&
          wordCenter <= centerX
        ) {
          word.classList.remove("is-launched");
          void word.offsetWidth;
          word.classList.add("is-launched");
          armedWords.delete(word);
        }

        previousPositions.set(word, wordCenter);
      });

      animationFrame = window.requestAnimationFrame(checkWordPositions);
    };

    animationFrame = window.requestAnimationFrame(checkWordPositions);

    return () => {
      window.cancelAnimationFrame(animationFrame);
    };
  }, []);

  useEffect(() => {
    const notice = noticeRef.current;
    if (!notice) return undefined;

    notice.showModal();
    return () => notice.close();
  }, []);

  return (
    <>
    <dialog
      className="zine-notice"
      ref={noticeRef}
      aria-labelledby="zine-notice-title"
    >
      <p className="zine-notice-label">A note before you enter</p>
      <h2 id="zine-notice-title">
          This zine is not a substitute for the ideas it conveys.
          Thoughts of change does not equal change.
      </h2>
      <form method="dialog">
        <button className="zine-notice-close" type="submit">
          Enter the zine <span aria-hidden="true">→</span>
        </button>
      </form>
    </dialog>
    <main className="debord-zine">
      <header className="zine-masthead">
        <div className="zine-topline">
          <span>Scrapheap Zines</span>
          <span>Issue 001 · Work in progress</span>
        </div>

        <div className="zine-title-lockup">
          <span className="zine-stamp" aria-hidden="true">
            DZ
          </span>
          <h1>Debord<br />IS ONLINE</h1>
          <p>A scrapbook for the New Flesh.</p>
        </div>
      </header>

      <section className="zine-cover" id="opening" aria-labelledby="cover-title">
        <div className="zine-cover-copy">
          <p className="zine-kicker">A living document</p>
          <h2 id="cover-title">Reclaim Your Everyday Life</h2>
            <p className="zine-deck">
            Guy Debord wrote "The Society of the Spectacle" in 1967. He was a French theorist, filmmaker, and revolutionary who was a member of a movement known as the Situationist International.
            Together, they critiqued the modern ways of life and asked how much of your life are you actually living, and how much of it are you watching, purchasing, displaying?
          </p>
          <a className="zine-read-link" href="#field-notes">
            Enter the issue <span aria-hidden="true">↓</span>
          </a>
        </div>

        <figure className="zine-artwork zine-artwork-cover">
          <img
            className="zine-cover-image"
            src="/images/Debord.png"
            alt="Cover artwork for Debord Zine"
          />
          <span
            className="zine-cover-glitch"
            role="img"
            aria-label="Culture Shock. Future Shock."
          >
            <span className="zine-cover-message zine-cover-message-first" data-text="Culture Shock" aria-hidden="true">
              Culture Shock
            </span>
            <span className="zine-cover-message zine-cover-message-second" data-text="Future Shock" aria-hidden="true">
              Future Shock
            </span>
          </span>
          <figcaption>
            Useless information occupies every open space inside your skull.
          </figcaption>
        </figure>
        <div
          className="zine-conveyor"
          aria-label="Work, buy, watch, post, with occasional words: wander, talk, play, create, and love"
          ref={conveyorRef}
        >
          <div className="zine-conveyor-track" aria-hidden="true">
            {[0, 1].map((groupIndex) => (
              <div className="zine-conveyor-group" key={groupIndex}>
                {conveyorSegments.map((segment, segmentIndex) => (
                  segment.type === "word" ? (
                    <span className="zine-conveyor-insert" key={`${groupIndex}-${segment.id}`}>
                      {segment.text}
                      {" "}<span className="zine-conveyor-arrow">&rarr;</span>
                    </span>
                  ) : (
                    <span className="zine-conveyor-phrase" key={`${groupIndex}-${segment.id}`}>
                      Work <span className="zine-conveyor-arrow">&rarr;</span> Buy <span className="zine-conveyor-arrow">&rarr;</span> Watch <span className="zine-conveyor-arrow">&rarr;</span> Post <span className="zine-conveyor-arrow">&rarr;</span>
                    </span>
                  )
                ))}
              </div>
            ))}
          </div>
        </div>
        <span className="zine-cover-number" aria-hidden="true">01</span>
      </section>

      <section
        className="zine-opening-note"
        aria-labelledby="opening-title"
        style={{
          "--opening-note-position": "center 10%",
        }}
      >
        <img
          className="zine-opening-note-background"
          src="/images/debordTexture.jpg"
          alt=""
          aria-hidden="true"
        />
        <aside className="zine-spectacle-sidebar" aria-labelledby="spectacle-list-title">
          <span className="zine-sidebar-kicker">01 / The idea</span>
          <h2 className="spectacle-list-title">The Spectacle:</h2>
          <ul>
            <li>
              Separates people from direct activity, from each other, from
              their products, and from collective power
            </li>
            <li>Appears as a false unity</li>
            <li>Maintains people as passive spectators</li>
              <li>Is the inversion of life: the autonomous non-living</li>
              <br></br>
              
            <li>The spectacle is how we experience reality. It is how we talk, how we communicate, how we socialize with one another.</li>
              <li>It is what you call a society where market logic has colonized all forms of social life.</li>
              <li>It is the way we replace life with representation and images of experience.</li>
          </ul>
        </aside>
        <div>
          <h2 className="zine-opening-note-title" id="opening-title">
            The Spectacle has taken over
          </h2>
          <p className="zine-speech-bubble">
            "In societies where modern conditions of production prevail, life is presented as an immense accumulation of spectacles. Everything that was directly lived receded into a representation."
          </p>
          <p className="zine-speech-bubble">
            "The spectacle is not merely images or media; <b>it is the social relation mediated by images.</b>"
          </p>
        </div>
        <div className="zine-margin-note" aria-label="Margin note">
          <img
            className="zine-opening-note-image"
            src="/images/debord2.png"
            alt="Person pictured beside the opening note"
          />
        </div>
      </section>

      <section
        className="zine-field-notes"
        id="field-notes"
        aria-labelledby="field-title"
      >
        <img
          className="zine-field-notes-background"
          src="/images/phones.jpg"
          alt=""
          aria-hidden="true"
        />
        <div className="zine-section-heading">
          <div className="zine-section-marker">
            <span>02</span>
            {/* <span>Loose pages</span> */}
          </div>
          <h2 id="field-title">Separation Perfected</h2>
        </div>

        <div className="zine-spread">
          <article className="zine-note zine-note-feature">
            <p className="zine-kicker">Essay / fragment</p>
            <h3>The spectacle as separation</h3>
            <p>
              The separation of workers from their product, consumers from the labor, and individuals from political power leaves space for the spectacle to insert itself in these gaps and provide a representation of actual activity. The spectacle then offers symbolic compensation for us rather than true activity to overcome the separation. Real separation creates the need for spectacular representation, spectacular representation then pacifies, organizes, and deepens the real separation.
            </p>
          </article>

          <aside className="zine-separation-widget" aria-labelledby="separation-widget-title">
            <p className="zine-kicker">What gets represented</p>
            <h3 id="separation-widget-title">Spectatorship in...</h3>
            <dl>
              <div>
                <dt>Meaningful activity through...</dt>
                <dd>Images of adventure, creativity, and success</dd>
              </div>
              <div>
                <dt>Political power through...</dt>
                <dd>Politics watched as drama, or identification with leaders</dd>
              </div>
              <div>
                <dt>Human connection through...</dt>
                <dd>Belonging experienced through brands, fandoms, nationalism, and lifestyle images</dd>
              </div>
              <div>
                <dt>Labor behind commodities through...</dt>
                <dd>The commodity encountered as pure image, detached from production</dd>
              </div>
            </dl>
          </aside>

          <blockquote className="zine-pull-quote">
            <p>Separation produces the spectacle, and the spectacle produces separation</p>
          </blockquote>

          <article className="zine-note zine-note-small">
            <img
            className="zine-note-image"
            src="/images/spectatorship.jpg"
            alt=""
          />
          </article>
        </div>
      </section>

      <section
        className="zine-concert-case"
        id="concerts"
        aria-labelledby="concert-title"
        style={{
          "--concert-background-image": 'url("/images/live.jpg")',
          "--concert-secondary-background-image": 'url("/images/live2.jpg")',
        }}
      >
        <div className="zine-section-heading zine-concert-heading">
          <div className="zine-section-marker">
            <span>03</span>
            <span>An Example</span>
          </div>
          <h2 id="concert-title">The Concert as a Spectacle</h2>
        </div>

        <p className="zine-concert-lede">
          Today, going to a concert becomes less an activity one participates in, and
          more an image one produces of having participated in
        </p>

        <ol className="zine-concert-sequence">
          <li>
            <span>01 / Direct activity would be</span>
            <p>Listening, dancing, being with others, sharing a performance.</p>
          </li>
          <li>
            <span>02 / Representational mediation is</span>
            <p>Recording, posting, curating the experience.</p>
          </li>
          <li>
            <span>03 / Social recognition gained includes</span>
            <p>
              proof of identity, taste, status, and
              belonging.
            </p>
          </li>
          <li>
            <span>04 / The Spectacular inversion occuring is</span>
            <p>
              The image of having lived the experience becomes more socially
              important than the experience itself.
            </p>
          </li>
        </ol>

        <aside
          className="zine-concert-caveat"
          style={{
            "--concert-caveat-texture": 'url("/images/texture2.jpg")',
          }}
        >
          <span className="zine-kicker">A distinction worth keeping</span>
          <p>
            Not every photo or recording automatically makes the event a
            spectacle. The key is when representation becomes the organizing
            purpose of the activity. Taking a photo to remember the night is not
            alone a spectacle. But if the event is lived primarily as content,
            the event that was meant to be lived has moved away into
            representation.
          </p>
        </aside>

        <div className="zine-concert-analysis">
          <article className="zine-concert-separation">
            <p className="zine-kicker">The concert as separation perfected</p>
            <ul>
              <li>Separation from the present moment</li>
              <li>Separation from others physically at the show</li>
              <li>
                Separation from one&apos;s own experience while watching through
                an image
              </li>
              <li>
                Separation from the performance as it is consumed as an identity
                sign rather than an activity
              </li>
            </ul>
          </article>
          <article className="zine-concert-unity">
            <p className="zine-kicker">False unity in the concert</p>
            <p>
              The crowd may appear unified because everyone is in the same
              place, oriented toward the same performance. But if each person is
              experiencing the event through representation and image
              production, no one is experiencing it together. Those who watch
              through posts, clips, and trends also create a larger imagined
              community of fans and followers—but that community exists as
              spectators.
            </p>
            <p className="zine-concert-last-line">
              The concert reunites the separate, but reunites them only in
              their separateness.
            </p>
          </article>
        </div>
      </section>

      <section
        className="zine-representation-question"
        aria-labelledby="representation-question-title"
      >
        <h2 id="representation-question-title">
          Where else do you replace life with representation?
        </h2>
        <p className="zine-representation-word" aria-hidden="true">
          <span key={representationWordIndex}>
            {representationWords[representationWordIndex]}
          </span>
        </p>
        <span className="zine-sr-only">
          Examples include: {representationWords.join(", ")}.
        </span>
      </section>

      <section className="zine-media-shelf" id="media" aria-labelledby="media-title">
        <div className="zine-section-heading">
          <div className="zine-section-marker">
            <span>04</span>
            <span>Notes</span>
          </div>
          <h2 id="media-title">The Spectacle as the new Chief Commodity</h2>
        </div>

        <div className="zine-media-stickers">
          {[1, 2, 3, 4, 5, 6, 7]
            .filter((tagNumber) => !dismissedStickerNumbers.has(tagNumber))
            .map((tagNumber) => (
              <button
                aria-label={`Remove price sticker ${tagNumber}`}
                className={`zine-media-sticker zine-media-sticker-${tagNumber}`}
                key={tagNumber}
                onClick={() => {
                  setDismissedStickerNumbers((numbers) => new Set(numbers).add(tagNumber));
                }}
                type="button"
              >
                <img src={`/images/tag${tagNumber}.png`} alt="" />
              </button>
            ))}
        </div>

          <div className="zine-media-grid">
          <article className="zine-note zine-note-feature">
            <p style={{ color: "black"}}>
              The commodity represents exchange-value, status, desire and social meaning. But Debord says at later stages of capitalism, that representation the commodity holds becomes dominant enough that society itself appears as a world of images. When the commodity was dominant, social labor and social relations are hidden inside objects for exchange. When the spectacle becomes dominant the whole social world becomes organizes as appearance, display, image, representation, and passive contemplation.
            </p>
          </article>
          <article className="zine-media-card zine-audio-card">
            <span className="zine-media-icon" aria-hidden="true">N</span>
            <div>
              <h3>With commodity</h3>
              <p>
                relations among people appear as relations among things
              </p>
            </div>
          </article>
          <article className="zine-media-card zine-video-card">
            <span className="zine-media-icon" aria-hidden="true">F</span>
            <div>
              <h3>With spectacle</h3>
              <p>
                relations among people appear as relations among images
              </p>
            </div>
          </article>
          <p className="zine-media-declaration">
            The spectacle is the moment when the commodity has attained the total occupation of social life. Market logic no longer is confined to buying and selling. It structures time, space, leisure, politics, culture, desire, and identity.
          </p>
        </div>
        <img
          className="zine-media-buy-now"
          src="/images/buynow.png"
          alt="Buy Now"
        />
        <img
          className="zine-media-social"
          src="/images/social.png"
          alt=""
          aria-hidden="true"
        />
      </section>

      <section
        className="zine-real-spectacle"
        id="real-spectacle"
        aria-labelledby="real-spectacle-title"
        style={{
          "--real-spectacle-background-image": 'url("/images/background2.jpg")',
          "--real-spectacle-ariana-image": 'url("/images/ariana3.png")',
          "--real-spectacle-kony-image": 'url("/images/kony.jpg")',
        }}
      >
        <div className="zine-real-spectacle-kony" aria-hidden="true" />
        <div className="zine-real-spectacle-heading">
          <div className="zine-section-marker">
            <span>05</span>
            <span>Abstraction</span>
          </div>
          <h2 id="real-spectacle-title">The spectacle as a real object</h2>
        </div>

        <p className="zine-real-spectacle-intro">
          Debord clarifies that the spectacle is not merely an abstract construct. It is real and present
          in the objects and systems around us, in the behavior they organize,
          and in the effects they leave on actual life.
        </p>

        <div className="zine-real-spectacle-grid">
          <article>
            <span className="zine-kicker">01 / Material presence</span>
            <p>
              Screens, cities, workplaces, advertisements, commodities,
              institutions, media systems, politics, and the celebrity industry.
            </p>
          </article>
          <article>
            <span className="zine-kicker">02 / Organized behavior</span>
            <p>
              Buying, voting, desire, comparison, travel, dating, and protest.
            </p>
            <p className="zine-real-spectacle-note">
              NOTE: These activities are not inherently wrong. The problem
              is when representation substitutes for actual participation in
              them.
            </p>
          </article>
          <article>
            <span className="zine-kicker">03 / Real effects</span>
            <p>
              Isolation, passivity, aspiration, false belonging,
              depoliticization, competition, and manufactured desire.
            </p>
          </article>
        </div>

        <p className="zine-real-spectacle-context">
          It expresses a real society through visible forms. Through commodity
          production, alienated labor, and separation. Its effects are just as
          real and they shape actual life.
        </p>

        <blockquote className="zine-real-spectacle-quote">
          <p>
            “The spectacle is the real form taken by an unreal, inverted social
            life.”
          </p>
          <cite>— Guy Debord</cite>
        </blockquote>
      </section>

      <section
        className="zine-next-question"
        aria-labelledby="next-question-title"
        style={{
          "--next-question-background": 'url("/images/touch.jpg")',
        }}
      >
        <h2 id="next-question-title">The Revolution of Everyday Life</h2>
      </section>
      <section
        className="zine-situationists"
        aria-labelledby="situationists-title"
        style={{
          "--situationists-slogan-image": 'url("/images/slogan.jpg")',
          "--situationists-title-image": 'url("/images/si.jpg")',
        }}
      >
        <div className="zine-situationists-heading">
          <p className="zine-kicker">A movement</p>
          <h2 id="situationists-title">Who were the Situationists?</h2>
        </div>

        <div className="zine-situationists-intro">
          <p>
            In 1957, artists, writers, theorists, and revolutionaries came
            together to form the <strong>Situationist International</strong>.
          </p>
          <p>
            They believed capitalism, specifically through the spectacle, had transformed our social relations and <strong>everyday life itself</strong>.
          </p>
        </div>

        <p className="zine-situationists-context">
          Modern life was increasingly organized around consumption,
          commodities, images, work, entertainment, and experiences prepared in
          advance by forces and systems outside of our control. People were becoming
          spectators of a world produced for them rather than active
          participants in creating their own lives.
        </p>

        <p className="zine-situationists-pivot">
          The Situationists wanted to change that.
        </p>
        <h3 className="zine-situationists-thesis">
          They wanted to <strong>abolish the separation between art and everyday life.</strong>
        </h3>

        <ul className="zine-situationists-actions">
          <li>To wander through cities without predetermined destinations.</li>
          <li>To hack advertisements and cultural images and turn them against themselves.</li>
          <li>To interrupt routines.</li>
          <li>To experiment with new ways of living.</li>
          <li>To create situations rather than consume them.</li>
          <li>To transform ordinary existence into something actively constructed by the people living it.</li>
        </ul>
      </section>

      <section
        className="zine-participant"
        id="participant"
        aria-labelledby="participant-title"
        style={{
          "--participant-background-image": 'url("/images/aphex.jpg")',
        }}
      >
        <img
          className="zine-participant-background4"
          src="/images/background4.png"
          alt=""
          aria-hidden="true"
        />
        <img
          className="zine-participant-sadie"
          src="/images/sadie.jpg"
          alt=""
          aria-hidden="true"
        />
        <div className="zine-participant-heading">
          <div className="zine-section-marker">
            <span>08</span>
            <span>Make something happen</span>
          </div>
          <h2 id="participant-title">
            Become a participant rather than a spectator.
          </h2>
        </div>

        <p className="zine-participant-intro">
          Debord and the Situationists International attacked passivity, spectatorships and any other forms of engaging reality through consumption. And you should too. Whenever possible, convert consumption
          into activity.
        </p>

        <div className="zine-participant-actions">
          <article>
            <span>01</span>
              <p><strong>Music:</strong> Instead of listening to music, create it. Learn an instrument. Make music no one will listen to.</p>
          </article>
          <article>
            <span>02</span>
              <p><strong>Cook:</strong> Instead of just watching cooking videos, get in the kitchen and cook. Experiment with food. Try new dishes.</p>
          </article>
          <article>
            <span>03</span>
              <p><strong>Art:</strong> Instead of passively consuming art. Create it. Drawing, painting, writing, theater, anything. Let your creative side express itself.</p>
          </article>
          <article>
            <span>04</span>
              <p><strong>Reading</strong>: Instead of just consuming information, engage with texts critically and create your own interpretations.</p>
          </article>
        </div>
        <p className="zine-participant-final">
          Prevent consumption from becoming the dominant relationship with reality. And prevent economic value from becoming the reason you produce. 
        </p>
      </section>

      <section
        className="zine-uncommodified-time"
        id="uncommodified-time"
        aria-labelledby="uncommodified-time-title"
        style={{
          "--uncommodified-time-background-image": 'url("/images/papertext.png")',
        }}
      >
        <img
          className="zine-uncommodified-time-playing"
          src="/images/playing.jpg"
          alt=""
          aria-hidden="true"
        />
        <div className="zine-uncommodified-time-heading">
          <img
            className="zine-uncommodified-time-working"
            src="/images/working.jpg"
            alt=""
            aria-hidden="true"
          />
          <div className="zine-section-marker">
            <span>09</span>
            <span>Take it back</span>
          </div>
          <h2 id="uncommodified-time-title">Take back your time</h2>
        </div>

        <p className="zine-uncommodified-time-intro">
          Capitalism has colonized time itself. Work produces commodities while leisure gets organized around consuming them. Time with friends, family, loved ones is incorporated into a work schedule. Take your time back.
        </p>

        <div className="zine-time-cycle" aria-label="Work, earn, consume, return to work">
          <span>Work</span>
          <span aria-hidden="true">→</span>
          <span>Get paid</span>
          <span aria-hidden="true">→</span>
          <span>Purchase entertainment</span>
          <span aria-hidden="true">→</span>
          <span>Consume it</span>
          <span aria-hidden="true">→</span>
          <span>Return to work</span>
        </div>

        <div className="zine-uncommodified-time-resist">
            <p><strong>Produce nothing economically useful. Create time whose value comes from having lived it, rather than from
            what it produces.</strong></p>
        </div>
      </section>

      <section
        className="zine-resist-representation zine-refuse-package"
        id="resist-representation"
        aria-labelledby="resist-representation-title"
      >
        <img
          className="zine-resist-representation-identity"
          src="/images/identity.jpg"
          alt=""
          aria-hidden="true"
        />
        <div className="zine-resist-representation-heading">
          <div className="zine-section-marker">
            <span>10</span>
            <span>Refuse the package</span>
          </div>
          <h2 id="resist-representation-title">
            Resist identity through commodity
          </h2>
        </div>

        <aside className="zine-resist-representation-popup" aria-label="Advertisement">
          <div className="zine-resist-representation-popup-bar" aria-hidden="true">
            <span>ADVERTISEMENT</span>
            <span className="zine-resist-representation-popup-close">×</span>
          </div>
          <img
            src="/images/goth.png"
            alt="How to Be a Goth by Tish Weinstock"
          />
        </aside>

        <p className="zine-resist-representation-intro">
          The spectacle encourages people to understand themselves through
          things that can be displayed. Even counterculture becomes a
          spectacular commodity. Everything is a purchasable identity package.
        </p>

        <aside className="zine-identity-distinction">
          <span className="zine-kicker">A distinction worth keeping</span>
          <p>
            This doesn&apos;t mean stop caring about clothing or music. Just be
            suspicious when <strong>having something</strong> substitutes for
            <strong> actually being something</strong>.
          </p>
        </aside>

        <div className="zine-identity-cycle" aria-label="An example of identity shaped by commodities">
          <p>
            I <span key={`verb-${identityCycleIndex}`} className="zine-identity-cycle-item">{identityVerb}</span>{" "}
            <span key={`brand-${identityCycleIndex}`} className="zine-identity-cycle-item">{identityBrand}</span>,
            <br />
            so I am <span key={`identity-${identityCycleIndex}`} className="zine-identity-cycle-item zine-identity-cycle-result">{identityLabel}</span>.
          </p>
        </div>
        <div className="zine-scroll-tag" role="img" aria-label="Be the freak you wanna see. Just don't follow me.">
          <span className="zine-scroll-message zine-scroll-message-first" data-text="Be the freak you wanna see">
            Be the freak you wanna see
          </span>
          <span className="zine-scroll-message zine-scroll-message-second" data-text="Just don't follow me">
            Just don't follow me
          </span>
        </div>
      </section>

      <section
        className="zine-relationship-section"
        id="relationships"
        aria-labelledby="relationship-protection-title"
      >
          <div className="zine-relationship-protection">
            <div className="zine-section-marker">
              <span>10</span>
              <span>Keep life between the people living it</span>
            </div>
            <div className="zine-relationship-heading">
            <h2 id="relationship-protection-title">
              Relationships as Representations.
            </h2>
          </div>

          <div className="zine-time-division">
          <p className="zine-kicker">You have two clocks. But you live one life.</p>
          <div className="zine-time-division-grid">
            <article>
              <span>01 / Productive time</span>
              <p>This includes: work, school, studying, career development, networking.</p>
            </article>
            <article>
              <span>02 / Free time</span>
              <p>
                This includes: friends, relationships, wandering, playing, talking, and hobbies.
              </p>
            </article>
          </div>
        </div>

        <div className="zine-transform-life-analysis zine-relationship-analysis">
          <p>
            These categories do not share the same value. Work becomes the
            central organizing principle, while actually spending your life
            with others becomes something you have to make time for. Friendships have to fit around production.
          </p>
          <p className="zine-relations-line">
            Human relationships have become subordinate to schedules determined
            elsewhere.
          </p>
        </div>

          <p className="zine-relationship-refrain">
            Fuck your social network.
          </p>

          <p className="zine-relationship-principle">
            A relationship should exist primarily for the people involved in it. Not for the economic value it can produce, or the image it can create.
          </p>

          <ul className="zine-relationship-practices">
            <li>Having a conversation nobody records for once?</li>
            <li>Allowing parts of your life to remain invisible?</li>
            <li>Making friends because you like them and not because they can benefit you?</li>
          </ul>
        </div>
      </section>

      <section
        className="zine-situationist-ideas"
        id="situationist-ideas"
        aria-labelledby="situationist-ideas-title"
        style={{
          "--situationist-ideas-map": 'url("/images/cityMap.jpg")',
        }}
      >
        <div className="zine-situationist-ideas-heading">
          <div className="zine-section-marker">
            <span>11</span>
            <span>Tools for everyday life</span>
          </div>
          <h2 id="situationist-ideas-title">Situationist International Ideas</h2>
        </div>

        <img className="zine-situationist-collage zine-situationist-mics" src="/images/mics.png" alt="" aria-hidden="true" />
        <img className="zine-situationist-collage zine-situationist-building" src="/images/building.png" alt="" aria-hidden="true" />
        <img className="zine-situationist-collage zine-situationist-arch" src="/images/arch.png" alt="" aria-hidden="true" />
        <img className="zine-situationist-collage zine-situationist-headroom" src="/images/headroom.jpg" alt="" aria-hidden="true" />
        <img className="zine-situationist-collage zine-situationist-eyes" src="/images/eyes.png" alt="" aria-hidden="true" />
        <img className="zine-situationist-collage zine-situationist-tv" src="/images/tv.png" alt="" aria-hidden="true" />  

        <div className="zine-situationist-ideas-grid">
          <article className="zine-situationist-idea zine-derive">
            <p className="zine-kicker">01 / Practice the dérive</p>
            <h3>Drifting</h3>
            <p>
              Dérive or " to drift" means Abandoning routine. Wander according to curiosity. Interrupt the
              preprogrammed organization of your everyday life.
            </p>
            <figure className="zine-naked-city">
              <img
                src="/images/nakedCity.jpg"
                alt="Debord's psychogeographic map The Naked City, with city fragments connected by red arrows"
              />
              <figcaption><em>The Naked City</em> / Guy Debord</figcaption>
            </figure>
          </article>

          <article className="zine-situationist-idea zine-create-situations">
            <p className="zine-kicker">02 / Create situations</p>
            <h3>Construct situations yourself.</h3>
            <p>
              Don&apos;t accept situations constructed for you by corporations,
              institutions, entertainment industries, algorithms, or consumer
              culture.
            </p>
            <ul>
              <li>Get together with friends and talk until 3 a.m.</li>
              <li>Do nothing productive.</li>
              <li>Host dinners.</li>
              <li>Start a reading group.</li>
              <li>Make art.</li>
              <li>Create rituals and traditions among friends.</li>
              <li>Build weird software nobody asked for.</li>
              <li>Explore abandoned parts of your city.</li>
            </ul>
            <p className="zine-situationist-shift">
              The actual activity you do isn&apos;t the point. What's important is to move from
              “What activities can I buy?” to
              “What activities can I create?”
            </p>
          </article>

          <article className="zine-situationist-idea zine-detournement">
            <p className="zine-kicker">03 / Practice détournement</p>
            <h3>Turn the image against itself.</h3>
            <p>
              Take existing cultural material and turn it against its original
              meaning. Ads, comics, slogans, movies, corporate imagery, and
              political language can be recombined, remixed, parodied.
            </p>
            <p>
              Appropriate the preselected images around you and turn them into something personal. Into art.
            </p>
            <p className="zine-detournement-last">
                Mutate.<br />
                Hack.<br />
                Recombine.<br />
            </p>
          </article>
        </div>
      </section>

      <aside
        className="zine-spectacle-warning"
        id="spectacle-warning"
        aria-labelledby="spectacle-warning-title"
      >
        <div className="zine-spectacle-warning-heading">
          <span className="zine-kicker">12 / A warning</span>
          <h2 id="spectacle-warning-title">
            Don&apos;t let escaping the spectacle become another lifestyle product.
          </h2>
        </div>
        <div className="zine-spectacle-warning-copy">
          <p>
            Beware of buying into the “anti-tech minimalist lifestyle” sold to you
            on the internet.
          </p>
          <p>
            Capitalism&apos;s greatest weapon is its capacity to turn any
            criticism into another commodity.
            </p>
            <p>
              If you need to buy something to resist the spectacle. You're doing it wrong.
            </p>
        </div>
        <img
          className="zine-spectacle-warning-image"
          src="/images/less.jpg"
          alt="All you need is less"
        />
      </aside>

      <section
        className="zine-transform-life"
        id="transform-life"
        aria-labelledby="transform-life-title"
      >
        <div className="zine-transform-life-heading">
          <div className="zine-section-marker">
            <span>13</span>
            <span>A closing provocation</span>
          </div>
          <h2 id="transform-life-title">Revolt against the life you&apos;re told to live</h2>
        </div>

        <div className="zine-transform-life-main">
          <div className="zine-final-message-copy">
            <p>
                Why have the activities supposedly preparing you to live gained
                power over the life you&apos;re already living?
            </p>
            <p>Debord is not saying to abandon responsibilities.</p>
            <p>
              The goal is to refuse to treat friendship, love, wandering,
              conversation, leisure, and creativity as leftovers that are
              permitted only after all the productive work is finished. These
              supposedly unproductive experiences may be much closer to what all
              that productive activity was supposed to make possible in the first
              place.
            </p>
          </div>
          <div className="zine-transform-life-aside">
            <figure className="zine-transform-life-portrait">
              <img src="/images/debord2.jpg" alt="Guy Debord standing in a city street" />
            </figure>
            <div className="zine-quote-card-stack" aria-label="Rotating quote cards">
              <blockquote className="zine-quote-card zine-quote-card-one">
                “The passions have been sufficiently interpreted; the point now is to discover new ones. ”
              </blockquote>
              <blockquote className="zine-quote-card zine-quote-card-two">
                “I have written less than most writers. But I have drunk far more than most drinkers.”
              </blockquote>
              <blockquote className="zine-quote-card zine-quote-card-three">
                “Never work”
              </blockquote>
            </div>
            <p className="zine-quote-attribution">- Guy Debord</p>
          </div>
        </div>
        <aside className="zine-autonomy-quote">
          It may be impossible to abolish the spectacle for now, but we can
          create pockets of autonomy in everyday life.
        </aside>
        <aside className="zine-life-final-lines">
          <p>Work and life are supposed to prepare you for life but when does life finally get to happen? Your present life is continually sacrificed for future life.</p>
        </aside>
      </section>
      <aside className="zine-leaving-song" aria-label="A song to leave with">
        <span>A song to leave with</span>
        <p>Death Grips — <em>Turned Off</em></p>
      </aside>
    </main>
    <ScrollFeedback />
    </>
  );
};

export default DebordZine;
